<template>
  <div>
    <div id="map"></div>
  </div>
</template>

<script>
import { db } from '@/firebase/firebase'
export default {
  name: 'Map',
  data () {
    return {
      places: [],
      map: Object,
      mapOptions: Object
    }
  },
  mounted: function() {
    const _this = this
    db.collection('places').get().then(function(querySnapshot) {
      _this.places = querySnapshot.docs.map(doc => {
        var data = doc.data()
        data.id = doc.id
        return data
      })
      _this.renderMap()
    })
  },
  methods: {
    renderMap () {
      const _this = this
      //renderMap()の中身を書き換える
      _this.mapOptions = {
        center: new google.maps.LatLng(37.5638148, 140.9900094),
        zoom: 14,
        mapTypeId: 'roadmap'
      }
      _this.map = new google.maps.Map(document.getElementById("map"), _this.mapOptions)
      _this.places.map(function(v) {
        if(v.latLng) {
          var latLng = v.latLng.split(',')
          var lat = parseFloat(latLng[0])
          var lng = parseFloat(latLng[1])
          var marker = new google.maps.Marker({position: {lat,lng}, map: _this.map})
          var infoWindow = new google.maps.InfoWindow({ // 吹き出しの追加
                content: `<div><a href="/#/place/${v.id}" >${v.name}</a></div>` // 吹き出しに表示する内容
          });
          marker.addListener('click', function() { // マーカーをクリックしたとき
              infoWindow.open(_this.map, marker); // 吹き出しの表示
            });
        }
      })
    }
  }
}
</script>

<style scoped>
#map {
  height: 80vh;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Map.vue